import { render, staticRenderFns } from "./DeleteDeveloperClientModal.vue?vue&type=template&id=f0296d42&lang=pug"
import script from "./DeleteDeveloperClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeveloperClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports